<div class="cab-select {{ customClass }}" [style.width]="width">
  @if (label.length > 1) {
    <app-cab-label [label]="label" [required]="required" />
  }

  <div [style.pointerEvents]="disabled ? 'none' : ''">
    <ng-select
      [id]="id"
      [items]="items$ | async"
      [readonly]="isReadonly()"
      [formControl]="formControl"
      [placeholder]="placeholder | translate"
      class="w-100 {{ size }} {{
        showArrow ? 'cab-select-field-hide-arrow' : ''
      }}"
      [bindLabel]="bindLabel"
      [bindValue]="bindValue"
      [loading]="loading()"
      [typeToSearchText]="'TYPE_TO_SEARCH' | translate"
      [loadingText]="'LOADING' | translate"
      [notFoundText]="notFoundText | translate"
      [typeahead]="searchInput$"
      (change)="onChangeSelect($event)"
      [clearable]="clearable"
      (clear)="clearData($event)"
      [multiple]="multiple"
    />
  </div>

  @if (showValidationErrors()) {
    <div class="text-danger" [innerHTML]="errorMessagesHtml()"></div>
  }
</div>
